import { PortableText } from "@portabletext/react"; // , PortableTextReactComponents
import React from "react";

import { Button } from "@/components/elements/Button";
import { Text } from "@/components/elements/Text";

import { FAQSections, styles } from "./components";

export const FAQSanityCMS = ({ content }) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <Text as="h1" size="xl">
          {content.title}
        </Text>
        <PortableText value={content.intro} />
      </div>
      <FAQSections faqGroups={content.faqGroups} />
    </div>
  );
};

FAQSanityCMS.Preview = ({ title, faq, ctaText }) => {
  return (
    <div className={styles.preview}>
      <Text as="h2" size={"l"}>
        {title}
      </Text>
      {/* Pass in faqGroup prop with empty title and single faq array */}
      <FAQSections faqGroups={[{ title: "", faqs: faq }]} />
      <Button
        theme="outline-square"
        pageLink="FAQ"
        className={styles.preview_button}
      >
        {ctaText}
      </Button>
    </div>
  );
};
